import React, { type ReactNode } from "react";
import { Modal } from "@sumprio/ui";
import ModalPortalRoot from "./ModalPortalRoot";

export interface DeleteConfirmModalBaseProps {
  open: boolean;
  title: string;
  supportingText: ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  primaryLabel?: string;
  confirmDisabled?: boolean;
}

const DEFAULT_PRIMARY_LABEL = "Yes, Delete";

export default function DeleteConfirmModalBase({
  open,
  title,
  supportingText,
  onClose,
  onConfirm,
  primaryLabel = DEFAULT_PRIMARY_LABEL,
  confirmDisabled = false,
}: DeleteConfirmModalBaseProps) {
  return (
    <ModalPortalRoot open={open} variant="center">
      <Modal
        variant="center"
        open={open}
        onClose={onClose}
        closeOnBackdropClick={false}
        closeOnEscape={false}
        title={title}
        supportingText={supportingText}
        showFeaturedIcon
        featuredIconVariant="error"
        showCloseButton
        showCancelButton={false}
        showPrimaryButton="error"
        primaryLabel={primaryLabel}
        onPrimary={onConfirm}
        secondaryLabel="Cancel"
        showSecondaryButton
        onSecondary={onClose}
        showFooterDivider={false}
        showHeaderDivider={false}
        primaryButtonProps={{ size: "xs", disabled: confirmDisabled }}
        secondaryButtonProps={{
          variant: "brand-secondaryGrey",
          size: "xs",
          disabled: confirmDisabled,
        }}
      />
    </ModalPortalRoot>
  );
}
